import React from "react";
import Navbar from "./Navbar";
import CheckoutPageContent from "../component/CheckoutPage";

const Checkout = () => {
    return (
        <div>
            <Navbar />
            <CheckoutPageContent />
        </div>
    );
};

export default Checkout;
